import http from "../plugins/Axios";
let apis = {
  // 油品数据列表
  oilsList(data) {
    return http({
      url: "html/oils/index",
      method: "POST",
      data: data
    });
  },
  // 油品数据详情
  oilsDetail(data) {
    return http({
      url: "html/oils/detail",
      method: "POST",
      data: data
    });
  },
  // 油品筛选项列表
  oilsScreenList(data) {
    return http({
      url: "html/oils/item_list", // url = base url + request url
      method: "POST",
      data: data
    });
  },
  // 竞品数据列表
  competitorList(data) {
    return http({
      url: "html/competitor_product/index",
      method: "POST",
      data: data
    });
  },
  // 竞品数据详情
  competitorDetail(data) {
    return http({
      url: "html/competitor_product/detail",
      method: "POST",
      data: data
    });
  },
  // 竞品筛选项列表
  competitorScreenList(data) {
    return http({
      url: "html/competitor_product/item_list",
      method: "POST",
      data: data
    });
  },

  // 油品累心列表
  getOilsTypeListApi(data) {
    return http({
      url: "html/oils/oils_type_list",
      method: "POST",
      data
    });
  }
};
export default apis;
